import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

/**
 * Admin wallet endpoints served by corebackend (`Admin/Wallet`).
 * Not to be confused with walletService, which talks to the wallet backend.
 */
const service = createService(SERVICE_INSTANCES.adminWallet)

export const ADMIN_WALLET_INSTANCE = service.instanceKey

export const ADMIN_WALLET_ENDPOINTS = {
  VIEW_INDEX: "/admin/wallet/view/index",
} as const

export const adminWalletService = {
  instanceKey: service.instanceKey,

  viewIndex: () => service.get(ADMIN_WALLET_ENDPOINTS.VIEW_INDEX),
}
